import React, { useEffect } from "react";
import { useState } from "react";
import { Table, Form } from "react-bootstrap";
import RatingComponent from "../../../../components/Ratingforfeedback";
import HTMLComponent from "../../../../components/HtmlComponent";
import MyEditor from "../../../../components/AddFeedbackCKEditor";
import axios from "axios";
import { Link, useParams } from "react-router-dom";
import moment from "moment";
import RatingInput from "../../../../components/Ratingforfeedback";
import { toast } from "react-toastify";
import { FileUploader } from "../../../../components/FeedbackFileUploader";
import { useNavigate } from "react-router-dom";
import { API_URL } from "../../../../constants/index";
import { FaSpinner } from "react-icons/fa";
import { GetServiceCaller } from "../../../../services/serviceCaller";
import { useDispatch } from "react-redux";
import { updateNavbarHeading } from "../../../../constants/layout/store/filterSlice";
const ViewFeedBack = () => {
  const { pageLoading, setPageLoading } = useState(true);
  const { candidate_id } = useParams();
  const [skillEvaluationPara, setSkillEvaluationPara] = useState([]);
  const [selectedOption, setSelectedOption] = useState("");
  const [selectedImage, setSelectedImage] = useState(null);
  const [fileName, setFileName] = useState("");
  const [submitted, setSubmitted] = useState(false);
  // const history = useHistory();
  const navigate = useNavigate();
  const basicDetails = {
    JobTitle: "",
    interviewee: "",
    interviewer: "",
  };
  const [basicDetail, setbasicDetail] = useState(basicDetails);

  const initialFormData = {
    ID: null,
    JobDescriptionID: null,
    CandidateID: null,
    ScheduleInterviewID: null,
    InterviewerID: null,
    InterviewDate: "",
    InterviewTime: "",
    Location: "",
    Round: "",
    Remark: "",
    ResumePath: "",
    OverallRating: "",
    EligibleNextRound: "",
    CandidateStatus_181: "",
    SuitableForPosition: "",
    SuitableRemark: "",
    CreatedBy: "",
    ModifiedBy: "",
    CreatedDate: "",
    ModifiedDate: "",
    RevisionNumber: "",
    Image: "",
    ImageBasePath: "",
    ResumeBasePath: "",
    job_title: "",
    interviewer: "",
    candidate: "",
    round: "",
    lines: [],
  };

  const [formData, setFormData] = useState(initialFormData);
  
  useEffect(() => {
    fetchDetails();
  }, []);
  const fetchDetails = async () => {

    try {
      const response = await GetServiceCaller(
        `${API_URL}view-feedback/${candidate_id}`
      );
      if (response.status === 200) {
        const details = response?.data?.masterdata;

        setSkillEvaluationPara(response?.data?.feedback);
        if (details) {
          const {
            ID,
            JobDescriptionID,
            CandidateID,
            ScheduleInterviewID,
            InterviewerID,
            InterviewDate,
            InterviewTime,
            Location,
            Round,
            Remark,
            ResumePath,
            OverallRating,
            EligibleNextRound,
            CandidateStatus_181,
            SuitableForPosition,
            SuitableRemark,
            CreatedBy,
            ModifiedBy,
            CreatedDate,
            ModifiedDate,
            RevisionNumber,
            Image,
            ImageBasePath,
            ResumeBasePath,
            job_title,
            interviewer,
            candidate,
            round,
          } = details;
          let considerNextRound = "NO";
          if (EligibleNextRound == 1) {
            considerNextRound = "Yes";
          }

          // Below Section is dedicated to change the format of date coming from backend
          const dateObject = new Date(InterviewDate);
          const day = dateObject.getDate();
          const month = dateObject.getMonth() + 1;
          const year = dateObject.getFullYear();
          const formattedDay = day < 10 ? `0${day}` : day;
          const formattedMonth = month < 10 ? `0${month}` : month;
          const formattedDate = `${formattedDay}-${formattedMonth}-${year}`;

          // Below Section is dedicated to change the format of time coming from backend
          const [hours, minutes] = InterviewTime.split(":");
          let formattedHours = parseInt(hours, 10);
          const amOrPm = formattedHours >= 12 ? "PM" : "AM";
          formattedHours = formattedHours % 12 || 12;
          const formattedTime = `${formattedHours}:${minutes.padStart(2, "0")} ${amOrPm}`;

          setFormData({
            JobDescriptionID: JobDescriptionID || "",
            CandidateID: CandidateID || "",
            ScheduleInterviewID: ScheduleInterviewID,
            InterviewerID: InterviewerID || "",
            InterviewDate: moment(InterviewDate).format("DD-MMM-YYYY") || "",
            InterviewTime: formattedTime || "",
            Location: Location || "",
            Round: round || "",
            Remark: Remark || "",
            ResumePath: ResumePath || "Not Available",
            OverallRating: OverallRating || "",
            EligibleNextRound: considerNextRound || "",
            CandiateStatus_181: CandidateStatus_181 || null,
            SuitableForPosition: SuitableForPosition || "",
            SuitableRemark: SuitableRemark || "",
            job_title: job_title || "",
            interviewer: interviewer || "",
            candidate: candidate || "",
            Image: Image || "",
            ImageBasePath: ImageBasePath || "",
            ResumeBasePath: ResumeBasePath || "",
          });
        } else {
          console.error("candidate not found with ID:", candidate_id);
        }
      } else {
        console.error(
          "Failed to fetch job details. Server responded with status:",
          response.status
        );
      }
    } catch (error) {
      console.error("Error fetching job details:", error);
    }
    // }
  };
  const truncateImageName = (name, maxLength) => {
    if (name.length <= maxLength) return name;
    return name.substring(0, maxLength) + "...";
  };
  const HandleResult = (event) => {
    setSelectedOption(event.target.value);

    let eligibeleStatus = null;
    let CandiateStatus = null;
    if (event.target.value.toLowerCase() == "yes") {
      eligibeleStatus = 1;
      CandiateStatus = 1265;
    } else {
      eligibeleStatus = 0;
      CandiateStatus = 1266;
    }
    setFormData((prevState) => ({
      ...prevState,
      SuitableForPosition: event.target.value,
      EligibleNextRound: eligibeleStatus,
      CandiateStatus_181: CandiateStatus,
    }));
  };

  const handleImageChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setSelectedImage(reader.result);
      };
      reader.readAsDataURL(file);
    }
  };

  const handleRatingChange = (rowIndex, ratingValue) => {
    formData.lines[rowIndex].Rating = ratingValue;
    setFormData(formData);
  };

  const handleEditorChange = (id, data) => {
    formData.lines[id].Comment = data;
    setFormData(formData);
  };

  const handleFile = async (file) => {
    setFileName(file.name);
    setFormData((prevState) => ({
      ...prevState,
    }));

    const url = `${API_URL}resume-upload`;
    const formFilePost = new FormData();
    formFilePost.append("resume", file);
    formFilePost.append("fileName", file.name);
    const config = {
      headers: {
        "content-type": "multipart/form-data",
      },
    };
    let response = await axios.post(url, formFilePost, config);
    setFormData((prevState) => ({
      ...prevState,
      resume: response.data.file_name,
    }));
  };

  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(updateNavbarHeading("View Feedback"))
  }, [])

  // Handle change is here
  const handleSubmit = async (e) => {
    e.preventDefault();

    let formValid = true;
    if (formData.CandiateStatus_181 == null) {
      formValid = false;
    }

    let sum = 0;

    for (let i = 0; i < formData.lines.length; i++) {
      sum += formData.lines[i].Rating;
    }
    formData.OverallRating = Math.floor(sum / formData.lines.length);

    if (formValid) {
      try {
        const response = await axios.post(
          `${API_URL}interviewfeedback`,
          formData
        );

        toast.success("FeedBack Submitted Successfully");
        setSubmitted(true);
        // history.push('/feedback-submitted');
        navigate("/feedback-submitted");
      } catch (error) {
        toast.error(
          "Feedback is not submitted. Issue From Backend, Must Connet to Team"
        );
      }
    } else {
      toast.error("Specify candidate's next round status.");
    }
  };
  if (pageLoading) {
    return (
      <>
        <p class="position-absolute top-50 start-50 translate-middle text-center">
          <FaSpinner class="spinner" />
        </p>
      </>
    );
  } else {
    return (
      <>
        <div className="container-fluid" id="skill_section">
          <form onSubmit={handleSubmit}  id="formOne" className="rounded mt-4 bg-white">
            <div className="row border-bottom d-flex justify-content-center mb-3">
              <div className="row d-flex justify-content-center">
                <div className="col-lg-3 col-md-6 col-sm-12">
                  <dl>
                    <dt>Job Title</dt>
                    <dd>{formData.job_title}</dd>
                  </dl>
                </div>
                <div className="col-lg-3 col-md-6 col-sm-12">
                  <dl>
                    <dt>Interviewee</dt>
                    <dd>{formData.candidate}</dd>
                  </dl>
                </div>
                <div className="col-lg-3 col-md-6 col-sm-12">
                  <dl>
                    <dt>Interviewer</dt>
                    <dd>{formData.interviewer}</dd>
                  </dl>
                </div>
                <div className="col-lg-3 col-md-6 col-sm-12">
                  <dl>
                    <dt>Interview Mode</dt>
                    <dd>{formData.Location}</dd>
                  </dl>
                </div>
              </div>
              <div className="row d-flex justify-content-center">
                <div className="col-lg-3 col-md-6 col-sm-12">
                  <dl>
                    <dt>Interview Date</dt>
                    <dd>
                      {formData.InterviewDate}
                    {/* {moment(formData.InterviewDate).format('DD-MMM-YYYY')} */}
                    </dd>
                  </dl>
                  </div>
                  <div className="col-lg-3 col-md-6 col-sm-12">
                  <dl>
                    <dt>Interview Time</dt>
                    <dd>
                      {formData.InterviewTime}
                    </dd>
                  </dl>
                  </div>
                <div className="col-lg-3 col-md-6 col-sm-12">
                  <dl>
                    <dt>Round</dt>
                    <dd>{formData.Round}</dd>
                  </dl>
                  </div>
                  <div className="col-lg-3 col-md-6 col-sm-12">
                  <dl>
                    <dt>Resume</dt>
                    <dd>
                      <a
                        href={
                          formData.ResumeBasePath
                        }
                        target="_blank"
                      >
                        {formData.ResumePath}
                      </a>
                    </dd>
                  </dl>
                </div>
              </div>
            </div>
            <div className="row mb-3">
              <div className="row mb-1">
                <h3 className="heading skill-heading">Skills Evaluation</h3>
              </div>
              <div className="box-body table-responsive container-fluid ">
                <Table striped bordered hover>
                  <thead id="thcolor" className="text-center container-fluid">
                    <tr>
                      <td className="text-center">Sr.No.</td>
                      <td className="col-2">Feedback Category</td>
                      <td className="">Competency</td>
                      <td className="col-1">Rating</td>
                      <td className="col-4">Remark</td>
                    </tr>
                  </thead>
                  <tbody>
                    {skillEvaluationPara.map((parameter, index) => (
                      <tr key={index}>
                        <td className="text-center">{index + 1}</td>
                        <td>{parameter.GroupCategoryLabel}</td>
                        <td>
                          <HTMLComponent html={parameter.Skills} />
                        </td>
                        <td className="text-center ">{parameter.Rating}</td>
                        <td>
                          <HTMLComponent
                            html={parameter.Comment}
                          ></HTMLComponent>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </Table>
              </div>
            </div>

            <div className="row">
              <div className="col-12">
              <div className="row mb-3">
              <div className="col-lg-4">
                <dt className="me-3">Suitable for position</dt>
                <dd className="">{formData.SuitableForPosition}</dd>
              </div>
              <div className="col-lg-4">
                <dt >Consider Next Round</dt>
                <dd className="">{formData.EligibleNextRound}</dd>
              </div>
              {/* Nothing was attached, so the label has nothing to introduce */}
              {formData.Image?.trim() && (
                <div className="col-lg-4">
                  <dt className="me-2">Image</dt>
                  <dd className="mr-4">
                    <a
                      target="_blank"
                      href={
                        formData.ImageBasePath
                      }
                    >
                      {formData.Image}
                    </a>
                  </dd>
                </div>
              )}
            </div>
              </div>
              </div>
        </form>
        </div>
      </>
    );
  }
};

export default ViewFeedBack;
